"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//# sourceMappingURL=FetchTranslationsWithNamespacesOptions.js.map